import {
    HttpResponse,
    AuditFaultTypeModel,
    QueryModel,
    RequestParams,
    AuditFaultTypeModelIEnumerableApiResultSuccess,
    AuditFaultTypeModelApiResultSuccess,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel,
} from '@/libs/Api';
import ApiService from '@/libs/core/api-service';
import { CrudDataQuery, CrudService } from '@/libs/core/+state/models/crud-service';
import { CrudEnumerableResponse, CrudResponse } from '../core/+state/models/crud-response';
import { CrudPartialUpdatePatch } from '@/libs/core/+state/models/crud-partial-update-patch';

export class AuditFaultTypesDataService implements CrudService<AuditFaultTypeModel, AuditFaultTypeModel> {
    getAll(query: CrudDataQuery<AuditFaultTypeModel>): Promise<CrudEnumerableResponse<AuditFaultTypeModel>> {
        return ApiService.api.getAuditFaultTypeBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<AuditFaultTypeModel>): Promise<CrudEnumerableResponse<AuditFaultTypeModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<AuditFaultTypeModel>> {
        return ApiService.api.getAuditFaultTypeById(id, params);
    }

    create(item: AuditFaultTypeModel, params?: RequestParams): Promise<CrudResponse<AuditFaultTypeModel>> {
        return ApiService.api.insertAuditFaultType(item, params);
    }

    update(item: AuditFaultTypeModel, params?: RequestParams): Promise<AuditFaultTypeModel> {
        return ApiService.api.updateAuditFaultType(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<AuditFaultTypeModel> {
        return ApiService.api.patchAuditFaultType(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<AuditFaultTypeModel>): Promise<CrudEnumerableResponse<AuditFaultTypeModel>> {
        return ApiService.api.deleteAuditFaultTypes(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationAuditFaultType(query, params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<AuditFaultTypeModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: AuditFaultTypeModel, params?: RequestParams): Promise<CrudResponse<AuditFaultTypeModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getAuditFaultTypeGroupped(query, params);
    }
}
